import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import MainApiService from "../../../../../services/mainApi.service";
import {
  AutoComplete,
  FormContainer,
  FormInput,
  SwitchInput,
  useFetch,
} from "@4uhub/lib4uhub";
import {
  registerCampaignSchema,
  TRegisterCampaignForm,
} from "./registerCampaignSchema";
import {
  createCampaign,
  getCampaignById,
  updateCampaign,
} from "../../../../../services/registerCampaign.service";
import { useCallback } from "react";

const GENERICS_ROUTE = process.env.REACT_APP_MAIN + "/api/v1/Generic/";
const genericService = new MainApiService(GENERICS_ROUTE);

const translationPath = "page.4uMarCom.campaigns.";

const RegisterCampaign = () => {
  const { t } = useTranslation();

  const { sendRequest: save, loading: sLoading } = useFetch(createCampaign);

  const { sendRequest: update, loading: uLoading } = useFetch(updateCampaign);

  const { sendRequest: get, loading: gLoading } = useFetch(getCampaignById);

  const formData = useCallback((value: TRegisterCampaignForm) => {
    return {
      ...value,
      description: value.description ?? undefined,
      campaignTypeId: value.campaignType.id,
    };
  }, []);

  const saveHandler = (v: TRegisterCampaignForm) => save(formData(v));

  const updateHandler = (v: TRegisterCampaignForm, id: string) =>
    update({ item: formData(v), id: id });

  const getHandler = useCallback(
    async (id: string) => {
      const { data, success } = await get(id);
      if (data && success) {
        return {
          data: {
            ...data,
            campaignType: {
              ...data.campaignType,
              name: data.campaignType.value,
            },
          },
          success,
        };
      }

      return { data: null, success: false };
    },
    [get]
  );

  const loading = sLoading || uLoading || gLoading;

  return (
    <FormContainer<TRegisterCampaignForm>
      saveFunction={saveHandler}
      updateFunction={updateHandler}
      getFunction={getHandler}
      loading={loading}
      title={t(translationPath + "campaign")}
      schema={registerCampaignSchema}
      subtitle={t(translationPath + "new")}
      subtitleWatchField={"name"}
      fields={() => (
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            sm={12}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <SwitchInput
              name="enable"
              label={t(translationPath + "enable") || "Enable"}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <FormInput
              size="small"
              name="name"
              fullWidth
              label={t(translationPath + "name") || "Name"}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <AutoComplete
              params={{ identifier: "CampaignType" }}
              getOptionLabel={(option) => option.name}
              size="small"
              label={t(translationPath + "type") || "Type"}
              name="campaignType"
              request={genericService.list}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <FormInput
              size="small"
              name="description"
              fullWidth
              multiline
              minRows={4}
              label={t(translationPath + "description") || "Description"}
            />
          </Grid>
        </Grid>
      )}
    />
  );
};

export default RegisterCampaign;
